<template>
    <div class="listmain ">
        <h1 class="firTitle">技能列表</h1>
        <h3 class="sedTitle">技能列表</h3>
        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">使用技能商店API获取技能列表</span>
        </p>
        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">request 参数</span>
        </p>
        <highlight-code lang="javascript">
           <span>
             {
    "access_token":"",
    "client_id":""
}
           </span>
        </highlight-code>

        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">请求的Domain</span>
        </p>
        <highlight-code lang="javascript">
           <span>
      /skills/app_skill_list
           </span>
        </highlight-code>
        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">respnse</span>
        </p>
        <highlight-code lang="javascript">
           <span>
     [{
	"skill_id": "orion.ovs.skill.1507716440282",
	"skill_name": "\u513f\u6b4c",
	"skill_icon_url": "",
	"skill_intro": "",
	"skill_invoke_num": 1017,
	"skill_type": "\u730e\u6237OS",
	"skill_cate_name": "",
	"update_time": "2017-11-21 12:44:19"
}...]
           </span>
        </highlight-code>

        <h3 class="sedTitle">技能详情</h3>
        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">request 参数</span>
        </p>
        <highlight-code lang="javascript">
           <span>
      {
    "access_token":"",
    "skill_id":""
}
           </span>
        </highlight-code>
        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">请求的Domain</span>
        </p>
        <highlight-code lang="javascript">
           <span>
     /skills/app_skill_info
           </span>
        </highlight-code>
        <p class="ql-long-7802039">
            <span class="ql-author-7802039 ql-size-9">respnse</span>
        </p>
        <highlight-code lang="javascript">
           <span>
    {
		"skill_id": "orion.ovs.skill.1508495296973",
		"skill_name": "\u65b0\u95fb",
		"skill_icon_url": "",
		"skill_intro": "",
		"skill_invoke_num": 1555,
		"skill_type": "\u730e\u6237OS",
		"skill_cate_name": "",
		"update_time": "2017-12-28 15:43:33",
		"skill_order_word": ["",""],
		"skill_version_intro": "",
		"support_device": ""
	}
           </span>
        </highlight-code>





        <!--<h3 class="sedTitle">控件接入</h3>-->


        <!--<p class="ql-long-7802039">-->
          <!--<span class="ql-author-7802039 ql-size-9">-->
       <!--1）通用控件接入<br>-->
<!--通用的技能列表的的接入由我们统一封装在OrionSkillFragment中（带标题栏），需要接入方将其放入自己不带标题栏的主界面的Activity中。也可以使用我们提供的ContainFragmentActivity进行接入。-->
          <!--</span>-->
        <!--</p>-->
        <!--<highlight-code lang="javascript" v-html="">-->
           <!--<span>-->
 <!--startActivity(ContainsFragmentActivity.getStartIntent(this,-->
                 <!--OrionSkillFragment.class, "", true, true));-->
       <!--</span>-->
        <!--</highlight-code>-->

        <!--<p class="ql-long-7802039">-->
          <!--<span class="ql-author-7802039 ql-size-9">-->
   <!--2）收藏模块接入<br>-->
<!--收藏模块我们封装在FavoritesFragment中（不带标题栏），需要接入方导入包含自定义标题栏的子界面的Activity中。也可以使用我们提供的ContainFragmentActivity进行接入。-->
          <!--</span>-->
        <!--</p>-->
        <!--<highlight-code lang="javascript" v-html="">-->
           <!--<span>-->
 <!--startActivity(ContainsFragmentActivity.getStartIntent(this,-->
                 <!--OrionFavoritesFragment.class, "我的收藏", false));-->
       <!--</span>-->
        <!--</highlight-code>-->
        <!--<p class="ql-long-7802039">-->
          <!--<span class="ql-author-7802039 ql-size-9">-->
  <!--3）闹钟模块接入<br>-->
<!--闹钟模块我们封装在AccountAlarmFragment中（不带标题栏），需要接入方导入包含自定义标题栏的子界面的Activity中。也可以使用我们提供的ContainFragmentActivity进行接入。-->
          <!--</span>-->
        <!--</p>-->
        <!--<highlight-code lang="javascript" v-html="">-->
           <!--<span>-->
 <!--startActivity(ContainsFragmentActivity.getStartIntent(this,-->
                 <!--OrionAccountAlarmFragment.class, "我的闹钟", false));-->
       <!--</span>-->
        <!--</highlight-code>-->
        <!--<p class="ql-long-7802039">-->
          <!--<span class="ql-author-7802039 ql-size-9">-->
 <!--4）AI口令模块接入<br>-->
<!--口令模块我们封装在CommandGuideFragment中（带标题栏），接入方可以导入无标题栏的子界面的Activity中。也可以使用我们提供的ContainFragmentActivity进行接入。-->
          <!--</span>-->
        <!--</p>-->
        <!--<highlight-code lang="javascript" v-html="">-->
           <!--<span>-->
  <!--startActivity(ContainsFragmentActivity.getStartIntent(this,-->
                 <!--OrionCommandGuideFragment.class, "我的口令", true, true));-->

       <!--</span>-->
        <!--</highlight-code>-->

        <!--<p class="ql-long-7802039">-->
          <!--<span class="ql-author-7802039 ql-size-9">-->
<!--5）情商模块接入<br>-->
<!--口令模块我们封装在OrionEQFragment.class中（带标题栏），接入方可以导入无标题栏的子界面的Activity中。也可以使用我们提供的ContainFragmentActivity进行接入。其中typeId为情商对应的SkillId，由服务器传递或参照OrionSkillRegister中定义的字段。-->
          <!--</span>-->
        <!--</p>-->
        <!--<highlight-code lang="javascript" v-html="">-->
           <!--<span>-->
  <!--OrionSkillRecord record = new OrionSkillRecord(OrionEQFragment.class, typeId);-->
 <!--ContainsFragmentActivity.start(mContext, record.getFragment(),-->
                <!--"", true, true, record.getBundle());-->
       <!--</span>-->
        <!--</highlight-code>-->
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Skill_list.vue